import {RefObject, useEffect, useRef} from 'react';

const useClickOutside = <T extends HTMLElement>(listener: (event?: UIEvent) => void): RefObject<T> => {
    const ref = useRef<T>(null);

    useEffect(() => {
        const handleListener = (event: UIEvent) => {
            if (ref.current && event.target instanceof Element && ref.current.contains?.(event.target)) {
                return;
            }
            listener(event);
        };

        document.addEventListener('mouseup', handleListener);
        return () => {
            document.removeEventListener('mouseup', handleListener);
        };
    }, [listener]);

    return ref;
};

export default useClickOutside;
